import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {OrdineSlave} from "../../../../../../models/OrdineSlave";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {GuiService} from "../../../../../../services/gui.service";
import {ProdottoFactory} from "../../../../../../models/Prodotto";
import {DialogService} from "../../../../../../components/generics/dialog/dialog.service";
import {ServerService} from "../../../../../../services/server.service";
import {
   AbstractControl,
   UntypedFormArray,
   UntypedFormControl,
   UntypedFormGroup,
   ValidationErrors,
   ValidatorFn,
   Validators
} from "@angular/forms";
import {Ordine} from "../../../../../../models/Ordine";
import {waterfall} from "async";
import {NgxSpinnerService} from "ngx-spinner";
import {PvenditaComponent} from "../../pvendita.component";
import {filter} from "rxjs/operators";
import {MatSliderChange} from "@angular/material/slider";
import {
   DialogWrapperComponent
} from "../../../../../../components/generics/dialog/dialog-wrapper/dialog-wrapper.component";


@Component({
   selector: 'app-pv-ordine-for-convalida',
   templateUrl: './pv-ordine-for-convalida.component.html',
   styleUrls: ['./pv-ordine-for-convalida.component.scss']
})
export class PvOrdineForConvalidaComponent implements OnInit, AfterViewInit {
   @ViewChild("fileInput") fileInput;
   @ViewChild("convalidaTemplate") convalidaTemplate;

   @Output() onSuccessConvalida = new EventEmitter<any>()
   @Output() onClose = new EventEmitter<any>()

   @Input() pVenditaID;
   @Input() ordineID;
   @Input() popupConvalideVisible: boolean = false;

   public vendorSlug;
   public ordine:Ordine = new Ordine({})
   public ordineSlave:OrdineSlave = new OrdineSlave({})
   public ordiniSlave: OrdineSlave[] = [];
   public ordineIndex:any;
   public prodForm: UntypedFormGroup;
   public filter: string = "";
   public popupVisible = false;
   public popupModConvVisible: boolean = false;
   public chiudi = false;
   public data_ricezione: any = null;
   public back_to_ordini = false;
   public qta: any;

   constructor(public route: ActivatedRoute,
               private guiSrv: GuiService,
               private prodottoFctr: ProdottoFactory,
               private dialogSrv: DialogService,
               private router: Router,
               private spinner: NgxSpinnerService,
               private pVenditaCom: PvenditaComponent,
               private serverSrv: ServerService) {

      this.route.pathFromRoot[3].params.subscribe(res => {
         this.vendorSlug = res.esercizio_slug
      })

      this.ordineID = this.route.snapshot.paramMap.get('ordine_id');
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
         this.pVenditaID = this.pVenditaCom._getPVenditaId()
      });

      this.route.queryParams.subscribe(params => this.back_to_ordini = params?.prev == "ordini");

      this.prodForm = new UntypedFormGroup({prodotti: new UntypedFormArray([], this.noZerosArrayValidator())});
   }

   ngOnInit(): void {
      waterfall([
         (next) => { this.loadOrdine().then(() => next(null)).catch(err => next(err)) },
         (next) => { this.loadOrdiniSlave().then(() => next(null)).catch(err => next(err)) }
      ], err => {
         if (err) this.dialogSrv.showToastError({err: err, msg:"Errore caricamento ordine"})
      })
   }

   ngAfterViewInit(): void {
      setTimeout(() => {
         $('input').on("wheel", () => {return false;});
      }, 300)

      this.dialogSrv.open(DialogWrapperComponent, {
            templateRef:this.convalidaTemplate,
            title:"Nuovo DDT",
            nome_scheda:"Nuovo DDT",
         },
         'custom-dialog-container-wrapper')
         .then().catch().finally(() => this.onClose.emit());
   }

   noZerosArrayValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
         const exists = (control as any).controls.some(c => c.value.qta > 0)
         return exists ? null : {zerosArray: true};
      };
   }

   get prodotti():UntypedFormArray {
      return this.prodForm?.controls?.prodotti as UntypedFormArray;
   }

   private async loadOrdine(){
      this.guiSrv.showLoading()
      return new Promise((resolve, reject) => {
         this.serverSrv.get(Ordine, `/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaID}/ordini_fornitore/${this.ordineID}`)
            .then(res => {
               this.ordine = res;
               this.guiSrv.hideLoading()
               resolve(null);
            })
            .catch(err => {
               reject(err)
               this.guiSrv.hideLoading()
            })
      })
   }

   private async loadOrdiniSlave(resetForm=false){
     await this.guiSrv.showLoading()
      return new Promise((resolve, reject) => {
         this.guiSrv.showLoading()
         this.serverSrv.getAll(OrdineSlave, `/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaID}/ordini_fornitore/${this.ordineID}/ordini_slave/convalide`)
            .then(res => {
               this.ordiniSlave = res;
               if (resetForm) this.prodForm = new UntypedFormGroup({prodotti: new UntypedFormArray([], this.noZerosArrayValidator())});
               for (let i = 0; i < this.ordiniSlave.length; i++){
                  this.prodotti.push(new UntypedFormGroup({
                     id: new UntypedFormControl(this.ordiniSlave[i].data.id),
                     qta: new UntypedFormControl({value: 0, disabled: (this.ordiniSlave[i].data.qta_rimanente == 0 || this.ordine.data?.is_convalida_chiusa)}, [Validators.required, Validators.min(0)]),
                  }))
                  this.guiSrv.hideLoading()
               }
               this.guiSrv.hideLoading()
               resolve(null);
            })
            .catch(err => {
               reject(err)
               this.guiSrv.hideLoading()
            });
      })
   }

   shouldHide(p){
      if (!this.filter) return false;
      if (p.PROD_DISPLAY?.toLowerCase().includes(this.filter)) return false;
      if (p.data?.ean?.toLowerCase().includes(this.filter)) return false;
      if (p.data?.vendor_prod_var_instance?.metrica_str?.toLowerCase().includes(this.filter)) return false;
      return true
   }

   openPopup(chiudi){
      this.popupVisible = true;
      this.chiudi = chiudi;
      this.data_ricezione = new Date();
   }

   private onConvalidaSuccess(){
      this.popupVisible = false;
      this.loadOrdine();
      this.loadOrdiniSlave(true);

      this.spinner.hide();
      this.onSuccessConvalida.emit()
      this.dialogSrv.showToastSuccess({title:"Convalida", msg: "Convalida creata con successo."});
      this.dialogSrv.closeAll();
   }

   private onConvalidaError(err){
      this.spinner.hide();
      this.dialogSrv.showToastError({err: err, msg: "Errore creazione convalida"});
   }

   convalidaClick($e){
      let data = $e.form
      let file = $e.file
      data['chiudi'] = this.chiudi
      data['prodotti'] = this.chiudi ? [] : this.prodotti.getRawValue()

      this.spinner.show();

      let url = `/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaID}/ordini_fornitore/${this.ordineID}/convalide`

      if (file.value?.files?.length){
         let files = [
            {name: "file", file: file.value.files[0]},
         ];

         let data_str = JSON.stringify(data)

         this.serverSrv.uploadFile(url, files, data_str, "post", null, true)
            .then(() => this.onConvalidaSuccess())
            .catch(err => this.onConvalidaError(err));
      }
      else {
         this.serverSrv.post(url, data)
            .then(() => this.onConvalidaSuccess())
            .catch(err => this.onConvalidaError(err));
      }
   }

   goBack(){
      let url = "../";
      if (this.back_to_ordini)
         url += "../";
      this.router.navigate([url], {relativeTo: this.route, queryParams:{stepIndex:1}})
   }

   clickModificaConv(ordineSlave, i) {
      this.ordineIndex = i
      this.popupModConvVisible = true
      this.ordineSlave = ordineSlave
      this.qta = this.ordineSlave.data.qta_convalidata
   }

   updateSetting($event: MatSliderChange) {
      this.qta = $event.value;
   }

   formatLabel(value: number): string {
      return `${value}`;
   }

   clickModificaConvalide() {
      let p = this.prodotti.controls[this.ordineIndex] as UntypedFormGroup
      p.controls['qta'].patchValue(this.qta - this.ordineSlave.data.qta_convalidata!)
      this.openPopup(false)
      this.popupModConvVisible = false;
   }

   closePopup() {
      this.popupConvalideVisible = false
      this.onClose.emit()
   }

   protected readonly Number = Number;

   checkQta(value: string, qta_rimanente: number) {
      if (parseInt(value) > qta_rimanente){
         this.dialogSrv.showToastError({title:"Errore Quantità", err:"Attenzione! Hai inserito una quantità maggiore rispetto alla quantità rimanente"})
      }
   }
}
